import React from 'react'
import createReactClass from 'create-react-class'
import _ from 'lodash'
import i18n from 'live/services/i18n'
import Service from './service'
import SenderModeForm from './sender-mode-form'
import serviceLocator from 'live/services/service-locator'

const TABLES = Service.getTables()
const TYPE = 'witsml-qgog'

const defaultObject = {
    type: 'liverig-' + TYPE,
    active: true,
    config: {
        endpoint: '',
        event_limit: 1000,
        enableForOutput: true,
        timestamp_mode: 'adjusted',
        curve_sets: {
            table0: {
                curve_map: {}
            },
            table1: {
                curve_map: {}
            }
        },
        wells: [],
        users: {},
        anonymous: true,
        mode: 'store',
        sender_username: '',
        sender_password: '',
        sender_interval: 60000,
        sender_delay: 60000,
        sender_window: 120000,
        sender_connect_timeout: 15000,
        sender_request_timeout: 15000
    },
    fullQualifier: '',
    qualifier: '',
    status: {}
}

const ValidationMixin = require('live/components/forms/mixins/validation-mixin')
const ObjectInitializerMixin = require('live/components/forms/mixins/object-initializer')(
    '/rest/extension',
    defaultObject
)
const FormBase = require('live/components/extensions/ui/form')
const FormGroup = require('live/components/forms/ui/form-group')
const Form = createReactClass({
    mixins: [ObjectInitializerMixin, ValidationMixin],
    validations: {
        properties: {
            config: {
                properties: {
                    endpoint: {
                        required: true,
                        allowEmpty: false,
                        message: i18n('Output URL') + ' ' + i18n('must not be empty')
                    },
                    event_limit: {
                        required: true,
                        allowEmpty: false,
                        message: 'Event Limit ' + i18n('must not be empty')
                    }
                }
            }
        }
    },

    onChangeTimestampMode: function (event) {
        var object = this.state.object
        var config = object.config

        config['timestamp_mode'] = event.target.value
        this.applyObj(config)
    },

    onChangeMode: function (event) {
        var object = this.state.object
        var config = object.config
        var mode = event.target.value

        config['mode'] = mode
        config['anonymous'] = true

        this.applyObj(config)
    },

    componentDidMount () {
        serviceLocator.getService('liverig-wells-shared-components').then(wellsService => {
            var Rigs = wellsService.Rigs

            this.setState({ Rigs })
        })
        serviceLocator.getService('liverig-curves-shared-components').then(curvesService => {
            var Users = curvesService.Users
            var Curves = curvesService.Curves
            var TimestampModes = curvesService.TimestampModes

            this.setState({ Curves, Users, TimestampModes })
        })
    },

    onChangeUsers (value) {
        var object = this.state.object
        let users = {}

        _.map(value, (user, i) => {
            users[(user && user.username) || '_order' + i] = {
                password: (user && user.password) || '',
                order: i
            }
        })

        object.config['users'] = users
        this.applyObj(object)
    },

    onChangeAnonymous (event) {
        var object = this.state.object

        object.config['anonymous'] = !event.target.checked

        this.applyObj(object)
    },

    onChangeCurves (table, values) {
        var object = this.state.object
        var curve_map = {}

        _.map(values, value => {
            if (!_.isEmpty(value)) curve_map[value.curve] = value.output_mnemonic || ''
        })

        object.config = {
            ...object.config,
            curve_sets: {
                ...object.config.curve_sets,
                [table]: {
                    curve_map
                }
            }
        }

        this.applyObj(object)
    },

    onChangeWell: function (wells) {
        var object = this.state.object
        var config = object.config

        config = {
            ...config,
            wells: _.map(wells, well => {
                return {
                    event_type: well.event_type,
                    include_extra: well.include_extra !== false,
                    curve_set: well.curve_set || 'table0'
                }
            })
        }

        object = {
            ...object,
            config
        }

        this.applyObj(object)
    },

    _onAfterFetch: function () {
        let object = this.state.object
        let config = object.config

        config = {
            ...config,
            ...Service.getCurveSets(config),
            ...Service.updateWells(config)
        }

        Service.removeCurves(config)

        // update state
        object = {
            ...object,
            config
        }

        this.applyObj(object)
    },

    _onSuccess: function () {
        window.location.href = '#/integrations/' + TYPE + '/' + this.state.object.id
    },

    _onDelete: function () {
        window.location.href = '#/integrations/'
    },

    render: function () {
        var uiCfg = {
            hideDivider: true
        }

        var object = this.state.object
        var config = object.config

        const { TimestampModes, Curves, Rigs, Users } = this.state

        let curveTable0 = (config && config.curve_sets && config.curve_sets[TABLES[0].value]) || {}
        let curveTable1 = (config && config.curve_sets && config.curve_sets[TABLES[1].value]) || {}

        return (
            <FormBase self={this} uiCfg={uiCfg} test={false}>
                <div className={'export-form ' + TYPE}>
                    <div className="form-area">
                        <FormGroup
                            type="text"
                            label={i18n('Output URL')}
                            name="config.endpoint"
                            value={config.endpoint}
                            placeholder={'http://127.0.0.1:52535/liverig/' + TYPE}
                            onChange={this.handleValidation}
                            validationState={this.validationState('config.endpoint')}
                            hasFeedback
                            help={this.errorsFor('config.endpoint')}
                        />

                        {TimestampModes ? (
                            <TimestampModes config={config} onChange={this.onChangeTimestampMode} />
                        ) : null}

                        <FormGroup
                            type="number"
                            label="Event Limit"
                            className="event-limit"
                            name="config.event_limit"
                            value={parseInt(config.event_limit)}
                            onChange={this.handleValidation}
                            validationState={this.validationState('config.event_limit')}
                            hasFeedback
                            help={this.errorsFor('config.event_limit')}
                        />

                        <div>
                            <div className="form-group clearfix">
                                <label>{i18n('Mode')}</label>

                                <label className="radio regular">
                                    <input
                                        type="radio"
                                        name="mode"
                                        value="store"
                                        checked={config.mode == 'store'}
                                        onChange={this.onChangeMode}
                                    />
                                    Store
                                </label>
                                <label className="radio regular">
                                    <input
                                        type="radio"
                                        name="mode"
                                        value="sender"
                                        checked={config.mode == 'sender'}
                                        onChange={this.onChangeMode}
                                    />
                                    Sender
                                </label>
                            </div>

                            {config.mode == 'sender' ? (
                                <SenderModeForm
                                    config={config}
                                    handleValidation={this.handleValidation}
                                    validationState={this.validationState}
                                    errorsFor={this.errorsFor}
                                />
                            ) : null}
                        </div>

                        {config.mode != 'sender' && Users ? (
                            <Users
                                onChange={this.onChangeUsers}
                                onChangeAnonymous={this.onChangeAnonymous}
                                object={object}
                                // customTableConfig={[
                                //     {
                                //         label: 'Username',
                                //         name: 'username',
                                //         type: 'text'
                                //     },
                                //     {
                                //         label: 'Password',
                                //         name: 'password',
                                //         type: 'password'
                                //     }
                                // ]}
                            />
                        ) : null}
                    </div>
                    <hr />

                    {Curves ? (
                        <div className="row curves-container">
                            <Curves
                                onChange={values => this.onChangeCurves(TABLES[0].value, values)}
                                config={config}
                                tableOnly={true}
                                curve_map={curveTable0 && curveTable0.curve_map}
                                enableOutput={true}
                                tableName={TABLES[0].label}
                            />
                            <Curves
                                onChange={values => this.onChangeCurves(TABLES[1].value, values)}
                                config={config}
                                tableOnly={true}
                                curve_map={curveTable1 && curveTable1.curve_map}
                                enableOutput={true}
                                tableName={TABLES[1].label}
                            />
                        </div>
                    ) : null}

                    <hr />
                    {Rigs ? (
                        <Rigs onChange={this.onChangeWell} config={config} curveSet={true} includeExtra={true} />
                    ) : null}
                </div>
            </FormBase>
        )
    }
})

module.exports = Form
